import { createContext } from 'react';

const CheckboxContext = createContext();

export default CheckboxContext;
